import { render, staticRenderFns } from "./domain-promo.vue?vue&type=template&id=3da6a4c8&scoped=true"
import script from "./domain-promo.vue?vue&type=script&lang=js"
export * from "./domain-promo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da6a4c8",
  null
  
)

export default component.exports